import { Const } from '../lib/const.cls'

export const getters = {
	[Const.GET_COUNTRIES_LIST]: (state) => { return state.countriesList },
	[Const.GET_USER_PROFILE]: (state) => { return state.userProfile },
	[Const.GET_CITIES_LIST]: (state) => { return state.citiesList },
	
	//email
	[Const.GET_EMAIL_SETTING_LIST]: (state) => {	return state.emailList },
	
	//coupon
	[Const.GET_COUPON_LIST]: (state) => {	return state.couponList },
	[Const.GET_SUB_EXSIST_LIST]: (state) => {	return state.subExistList },
	[Const.GET_SUB_PLAN_LIST]: (state) => {	return state.sunPlanList },
	[Const.GET_SUB_PLAN_DETAIL]: (state) => {	return state.subPlanDetail },
	
	//reporting
	[Const.GET_REPORTING_LIST]: (state) => {	return state.reportingList },
	[Const.GET_EMIR_LIST]: (state) => {	return state.emirList },
	
	//admin
	[Const.GET_ADMIN_LIST]: (state) => {	return state.adminList },
	[Const.GET_ADMIN_DETAIL]: (state) => {	return state.adminDetail },

	//admin document
	[Const.GET_PROFILE_DOCUMENT]: (state) => {	return state.adminDocumentDetail },
	
	//client
	[Const.GET_ARTICLE_LIST]: (state) => {	return state.articleList },
	[Const.GET_CAT_LIST]: (state) => {	return state.catList },
	[Const.GET_WITHDRAWAL_METHODS]: (state) => {	return state.withdrawalMethods },
	[Const.GET_WITHDRAWAL_METHOD_RESPONSE]: (state) => {	return state.withdrawalMethodResponse },
	
	[Const.GET_USER_LIST]: (state) => {	return state.userList },
	[Const.GET_LOGS_LIST]: (state) => {	return state.logsList },
	[Const.GET_LOGS_VIEW]: (state) => {	return state.logsView },
	[Const.GET_USER_VIEW]: (state) => {	return state.userView },
	[Const.GET_USER_COUNT]: (state) => {	return state.userCount },
	[Const.GET_EMP_STATUS]: (state) => {	return state.empStatus },
	[Const.GET_OCCUPATION]: (state) => {	return state.occupation },
	[Const.GET_EST_YEARLY_INCOME]: (state) => {	return state.estYearlyIncome },
	[Const.GET_EST_NET_WORTH]: (state) => {	return state.estNetWorth },
	[Const.GET_ACCOUNT_TURNOVER]: (state) => {	return state.antAccountTurnover },
	[Const.GET_GENDER_LIST]: (state) => {	return state.genderList },
	[Const.GET_INTERNAL_NOTES]: (state) => {	return state.internalNotes },
	[Const.GET_RISK_METRIX]: (state) => {	return state.riskMetrix },
	
	[Const.GET_IDEN_VER]: (state) => {	return state.idenVerList },
	[Const.GET_FUND_SRC]: (state) => {	return state.fundSrcList },
	[Const.GET_DEPT_METHD]: (state) => {	return state.deptMethdList },
	[Const.GET_CRED_INS]: (state) => {	return state.credInsList },
	[Const.GET_CHNL_RSK]: (state) => {	return state.chnlRiskList },
	[Const.GET_THRD_PARTY]: (state) => {	return state.thrdPartyList },
	[Const.GET_STEP]: (state) => {	return state.stepList },
	[Const.GET_TIMEZONE]: (state) => {	return state.timeZone },
	
	//ticket
	[Const.GET_TICKET_LIST]: (state) => {	return state.ticketList },
	[Const.GET_TICKET_VIEW]: (state) => {	return state.ticketView },
	[Const.GET_TICKET_REASON_LIST]: (state) => {	return state.ticketReasonList },
	[Const.GET_TICKET_DOCS]: (state) => {	return state.ticketDocs },

	[Const.GET_TICKET_DOCS_LINK]: (state) => {	return state.ticketDocsLink },
	[Const.GET_ZIP_DOCS_LINK]: (state) => {	return state.downloadUserZip},
	
	[Const.GET_DEPARMENT_LIST]: (state) => {	return state.department_list },
	[Const.GET_TICKET_STATUS]: (state) => {	return state.ticketStatus },
	[Const.GET_TICKET_REASON]: (state) => {	return state.ticketReason },

	//deposit
	[Const.GET_DEPOSIT_LIST]: (state) => {	return state.depositList },
	[Const.GET_DEPOSIT_VIEW]: (state) => {	return state.depositView },

	[Const.GET_DEPOSIT_STATUS]: (state) => {	return state.depositStatus },
	[Const.GET_DEPOSIT_METHOD]: (state) => {	return state.depositMethod },
	
	//bonus
	[Const.GET_BONUS_LIST]: (state) => {	return state.bonusList },
	[Const.GET_BONUS_VIEW]: (state) => {	return state.bonusView },
	
	//withdrawal
	[Const.GET_WITHDRAWAL_LIST]: (state) => { return state.withdrawalList },
	[Const.GET_WITHDRAWAL_VIEW]: (state) => { return state.withdrawalView },

	[Const.GET_WITHDRAWAL_TYPE]: (state) => { return state.withdrawalType },
	[Const.GET_WITHDRAWAL_METHOD]: (state) => { return state.withdrawalMethod },
	[Const.GET_WITHDRAWAL_STATUS]: (state) => { return state.withdrawalStatus },
	
	//trading
	[Const.GET_TRADING_LIST]: (state) => {	return state.tradingList },
	[Const.GET_TRADING_VIEW]: (state) => {	return state.tradingView },
	
	[Const.GET_CURRENCY]: (state) => { return state.currency },
	[Const.GET_DEMO_LIVE]: (state) => {	return state.demoLive },

	//bonus
	[Const.GET_BONUS_TYPE]: (state) => {	return state.bonusType },
	[Const.GET_BONUS_STATUS]: (state) => {	return state.bonusStatus },
	
	// user sub ib list
	[Const.GET_USER_SUBIB_LIST]: (state) => {	return state.subIbList },
	// commission
	[Const.GET_COMMISSION_HISTORY]: (state) => {	return state.commissionList },

	[Const.GET_REFERREL_LINK]: (state) => {	return state.referralLink },
}



// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/getters.js